import { Injectable } from '@angular/core';
import { BehaviorSubject, map, tap } from 'rxjs';
import { Observable,firstValueFrom } from 'rxjs';
import { VendorService } from 'src/app/services/vendor.service';
import { AuthService } from 'src/app/services/auth.service';
import { element } from 'protractor';
import { UtilsService } from './utils.service';
import { UtilsDataService } from './services/utils-data.service';

@Injectable({
  providedIn: 'root'
})
export class LoginDataService {

  constructor(
    private vendorService: VendorService,
    private authService: AuthService,
    private utilsService: UtilsService,
    private utilsDataService: UtilsDataService
  ) {}
  async validateVendor(email: string, p: string, role: string): Promise<{ success: boolean, role: any,email_verify_status: string  }> {
    const reqObj = { email, p,role };
    console.log("Request Object:", reqObj);
  
    try {
      const resp = await firstValueFrom(this.vendorService.validateVendor(reqObj));
      
      return this.handleLoginSuccess(resp);
    } catch (error) {
      console.error("Login failed sss", error);
      throw new Error("Login failed qqqq");
    }
  }
  async validateEmployee(email: string, p: string, role: string): Promise<{ success: boolean, role: any,email_verify_status: string  }> {
    const reqObj = { email, p,role };
    console.log("Request Object:", reqObj);
  
    try {
      const resp = await firstValueFrom(this.vendorService.validateEmployee(reqObj));
      
      return this.handleLoginSuccess(resp);
    } catch (error) {
      console.error("Login failed", error);
      throw new Error("Login failed");
    }
  }
  
  handleLoginSuccess(resp: any):  { success: boolean, role: any,email_verify_status: string,obj:any  } {
    if (resp.statusCode === 200) {
      this.vendorService.setVendorIdSubject(resp.data);
      this.authService.setLoggedIn(true);
      this.utilsService.setLoggedInStatus({
        loginStatus: true,
        role: resp.data.role,
        profileData: resp.data,
      });
      this.authService.roles.push(resp.data.role);
      this.utilsService.token=resp.token
      this.utilsDataService.vendorApplicationObj = resp?.data?.vendorApplicationModules
      
      console.log("Login success",this.utilsService.token);
      return { success: true, role: resp.data.role,email_verify_status: resp.data.email_verify_status,obj:resp.data };
      // return resp.data; // Return data to the component if needed
    } else {
      console.error("Login failed");
      throw new Error("Login failed");
    }
  }
  
  
}
